<template>
  <div class="border border-2 default-template-width rounded-3" id="section-to-print">
      <div class="border border-1 p-25 row">
        <div class="col-3 my-auto ps-50"><img :src="company.logo" :alt="company.name" class="w-44"></div>
        <div class="col-9 my-auto fw-bolder black-text p-0 main-text">{{ company.name }}</div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="my-25">
            <div class="text-blue">Name</div>
            <h4 class="black-text fw-bolder name-text">{{ limitText(cardInfo.full_name, 20) }}</h4>
          </div>
        </div>
        <div class="col-8">
          <div class="my-25">
            <div class="text-blue">Age & Sex</div>
            <h4 class="black-text fw-bolder main-text">
              {{ cardInfo.birthday ? (calculateAge(cardInfo.birthday) + ', ' + capitalize(cardInfo.gender)) : '' }}
            </h4>
          </div>
          <div class="my-25">
            <div class="text-blue">Contact no</div>
            <h4 class="black-text fw-bolder main-text">{{ getPatientDetails(cardInfo, 'mobile_no') }}</h4>
          </div>
        </div>
        <div class="col-4 my-auto">
          <div class="font-medium-5 my-25 black-text text-center">
            <div class="font-medium-5 black-text text-center">
              <div v-html="qrcode"></div>
              <div class="main-text mt-25 fw-bolder">ID: {{ cardInfo.serial_no }}</div>
            </div>
          </div>
        </div>
        <div class="border-top row">
          <div class="col-12 fw-bolder issue-text black-text text-center mt-1">
            <div class="col-12 fw-bolder issue-text black-text text-center m-0">
              Issue Date & Time: {{ formatDate(new Date()) }}
            </div>
          </div>
        </div>
      </div>
  </div>

</template>

<script setup>
import handleHospital from "@/services/modules/hospital";
import handleFormatter from "@/services/utils/figureFormatter";

const props = defineProps({
  company: {
    type: Object,
  },
  cardInfo:{
    type:Object
  },
  qrcode:{
    type:String
  },
})

const {calculateAge} = handleHospital();
const {
  capitalize,
  limitText,
  getPatientDetails,
  formatDate
} = handleFormatter();

</script>

<style>
.default-template-width .issue-text{
  font-size: 14px;
}
.default-template-width .text-blue {
  color: blue;
  font-size: 14px;
}
.default-template-width .main-text{
  font-size: 16px;
}
.default-template-width .name-text{
  font-size: 25px;
}
.default-template-width .black-text{
  --bs-text-opacity: 1;
  color: #000000 !important;
}
  .default-template-width {
    width: 4.1in;
    height: 2.5in;
  }
  @media print {
    body {
      visibility: hidden;
    }
    #section-to-print {
      visibility: visible;
      position: absolute;
      left: 0;
      top: 0;
    }
    @page {
      margin: 0;
    }
  }
  @page {
    size: 3.4in 2.1in;
  }
</style>
